module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promo"
  }, [(!_vm.showStatus) ? _c('div', [(_vm.showPromo) ? _c('div', [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', [_vm._v("Promo")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex ml-auto align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promoValue),
      expression: "promoValue"
    }],
    ref: "promoInput",
    staticClass: "glued-right",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.promoValue)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.validatePromo($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.promoValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn wide ok glued-left",
    on: {
      "click": _vm.validatePromo
    }
  }, [_vm._v("Apply")])])]), _vm._v(" "), (_vm.invalidPromo) ? _c('div', {
    staticClass: "error mt-1 mb-1"
  }, [_vm._v("Invalid promo code")]) : _vm._e()]) : _c('div', {
    staticClass: "bold"
  }, [_c('div', {
    on: {
      "click": _vm.openPromo
    }
  }, [_c('i', {
    staticClass: "ico-ticket color-6 fs-larger"
  }), _vm._v("\n                Do you have a promo code?\n            ")])])]) : _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "bold mr-2"
  }, [_vm._v(_vm._s(_vm.promoValue))]), _vm._v(" "), _c('i', {
    staticClass: "ico-check larger success"
  }), _vm._v(" "), _c('i', {
    staticClass: "ico-delete largest",
    on: {
      "click": _vm.resetPromo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v(_vm._s(_vm.promo.value.toFixed(2)) + "€")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-66354940", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66354940"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Promo.vue
// module id = 1217
// module chunks = 0